import { Link } from "react-router";
import { Alerta, Button, Card, Row, Spinner, Stack, TextField } from "@/components";
import { usePonderacionPorDefectoTab } from "./usePonderacionPorDefectoTab";

export function PonderacionPorDefectoTab() {
  const t = usePonderacionPorDefectoTab();

  return (
    <Stack espacio={6}>
      <h1 className="text-pantalla font-light tracking-[-0.03em]">Ponderación por defecto</h1>
      {t.cargando && (
        <div className="grid place-items-center py-10 text-primario">
          <Spinner />
        </div>
      )}
      {t.errorCarga && (
        <Stack espacio={3}>
          <Alerta texto={t.errorCarga} />
          <div>
            <Button variante="secundario" onClick={t.reintentar}>
              Reintentar
            </Button>
          </div>
        </Stack>
      )}
      {t.form && (
        <form onSubmit={(e) => void t.guardar(e)} noValidate>
          <Card>
            <Stack espacio={4}>
              <p className="text-chico text-texto-suave">
                Los multiplicadores de cada superficie que usa un departamento mientras no le cambies los suyos en la{" "}
                <Link to="/ponderacion" className="text-primario underline">
                  pestaña Ponderación
                </Link>
                . 1 = el m² cuenta entero; 0,5 = cuenta la mitad.
              </p>
              <Row espacio={3} envolver>
                <TextField etiqueta="× cubierta" inputMode="decimal" value={t.form.coef_cubierta} onChange={(e) => t.cambiar("coef_cubierta", e.target.value)} error={t.errores.coef_cubierta} contenedorClassName="w-32" />
                <TextField etiqueta="× semicubierta" inputMode="decimal" value={t.form.coef_semicubierta} onChange={(e) => t.cambiar("coef_semicubierta", e.target.value)} error={t.errores.coef_semicubierta} contenedorClassName="w-32" />
                <TextField etiqueta="× descubierta" inputMode="decimal" value={t.form.coef_descubierta} onChange={(e) => t.cambiar("coef_descubierta", e.target.value)} error={t.errores.coef_descubierta} contenedorClassName="w-32" />
              </Row>
              <Stack espacio={2} className="border-t border-borde pt-4">
                <h2 className="font-medium">Coef. altura estándar</h2>
                <p className="text-chico text-texto-suave">
                  Más alto, más caro; más bajo, más barato. Cada piso arranca con este coeficiente y en la pestaña Ponderación lo podés cambiar para un piso en particular.
                </p>
                <Row espacio={3} envolver>
                  <TextField etiqueta="1° piso" inputMode="decimal" value={t.form.coef_altura_base} onChange={(e) => t.cambiar("coef_altura_base", e.target.value)} error={t.errores.coef_altura_base} contenedorClassName="w-32" />
                  <TextField etiqueta="Sube por piso" inputMode="decimal" value={t.form.coef_altura_paso} onChange={(e) => t.cambiar("coef_altura_paso", e.target.value)} error={t.errores.coef_altura_paso} contenedorClassName="w-32" />
                </Row>
                {t.escala && (
                  <p className="text-chico" aria-label="Escala de coef. altura">
                    {t.escala}
                  </p>
                )}
              </Stack>
              <Alerta texto={t.error} />
              {t.guardado && (
                <p role="status" className="rounded-control bg-exito-suave px-3 py-2 text-chico text-exito">
                  Cambios guardados
                </p>
              )}
              <div>
                <Button type="submit" cargando={t.guardando}>
                  Guardar
                </Button>
              </div>
            </Stack>
          </Card>
        </form>
      )}
    </Stack>
  );
}
